import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faFileCsv,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { AuthGuard } from "../App";
import { EmailGuard } from "../App";
import { toast } from "react-toastify";
import { StandardURL } from "../App";


const RecordsPage = () => {
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [totalCommission, setTotalCommission] = useState(0);
  const [tax, setTax] = useState(0);
  const [actualWithdrawal, setActualWithdrawal] = useState(0);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [balance, setBalance] = useState(null);
  const [taxCash, setTaxCash] = useState(0); // Define taxCash as state
  const token = localStorage.getItem("token");

  const [amountup, setAmountUp] = useState("");
  const [waterbill, setWaterbill] = useState("");
  const [rentbill, setRentbill] = useState("");
  const [trashbill, setTrashbill] = useState("");
  const [servicebill, setServicebill] = useState("");
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [recordToUpdate, setRecordToUpdate] = useState(null);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    if (token) {
      // Fetch records
      axios
        .get(`${StandardURL}/iNyumba/viewrecordsrentadmin`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const fetchedRecords = response.data.response;
          // setRecords(fetchedRecords);

          // Filter records to only include those with a 'recordstatus' of 'running'
          const runningRecords = fetchedRecords.filter(
            (record) => record.recordsstatus === "running"
          );

          setRecords(fetchedRecords);
        })
        .catch((error) => {
          console.error("Error fetching records:", error);
        });


    axios
  .get(`${StandardURL}/iNyumba/commissionlink/fetch/all/meadmin`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  .then((response) => {
    const commissionData = response.data.response || {};
    const { kra_running, running_balance } = commissionData;

    // Validate required fields
    if (kra_running === undefined || running_balance === undefined) {
      console.warn("Response missing kra_running or running_balance");
      return;
    }

    // Set state with specific fields
    setTotalCommission(running_balance); // Assuming running_balance is the total commission
    setTax(kra_running); // Assuming kra_running is the tax amount
    setTaxCash(kra_running); // If taxCash is the same as tax, consider consolidating
  })
  .catch((error) => {
    console.error("Error fetching commission data:", error.message);
    // Optionally notify the user (e.g., show a toast or alert)
  });

      // Fetch balance
      axios
        .get(
          `${StandardURL}/iNyumba/admin/househunter/fetchinyumbabalance`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          if (response.data && response.data.response.length > 0) {
            const fetchedBalance = response.data.response[0].balance;
            setBalance(fetchedBalance);
          }
        })
        .catch((error) => {
          console.error("Error fetching balance:", error);
          toast.error(error.response.data.response);
        });
    }
  }, [token]);

  useEffect(() => {
    if (balance !== null && taxCash !== null) {
      // Calculate actual withdrawal: balance - (tax + 65)
      const calculatedWithdrawal = totalCommission - 75.4;
      setActualWithdrawal(calculatedWithdrawal);
    }
  }, [balance, taxCash]); // Add balance and taxCash as dependencies

  const handleDownload = (fileType) => {
    const endpoint = `${StandardURL}/iNyumba/reportsdownloadadmin`;

    // Fetch and download file
    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { format: fileType },
        responseType: "blob", // Important for file download
      })
      .then((response) => {
        const fileExtension = fileType === "pdf" ? "pdf" : "csv";
        const fileName = `inyumbapaidrentrecords.${fileExtension}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        toast.success("Download is successfull");
      })
      .catch((error) => {
        console.error(`Error downloading ${fileType.toUpperCase()}:`, error);
        toast.error(error.response.data.response);
      });
  };

  const handleFilteredDownload = (fileType) => {
    const endpoint = `${StandardURL}/iNyumba/reportsdownloadbymonthandyear`;

    // Fetch and download file
    axios
      .post(
        endpoint,
        { year, month }, // JSON body with year and month
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { format: fileType }, // Query parameter for format
          responseType: "blob", // Important for file download
        }
      )
      .then((response) => {
        const fileExtension = fileType === "pdf" ? "pdf" : "csv";
        const fileName = `inyumbapaidrentrecords_${year}_${month}.${fileExtension}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        toast.success("Download is successful");
      })
      .catch((error) => {
        console.error(`Error downloading ${fileType.toUpperCase()}:`, error);
        toast.error(error.response.data.response);
      });
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const updateOneRecord = (records_id) => {
    const token = localStorage.getItem("token");
    axios
      .patch(
        `${StandardURL}/iNyumba/updateonerecordadmin/${records_id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
      })
      .catch((error) => {
        console.error("Error updating record status:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleDeleteRecord = (recordIdsDel) => {
    const token = localStorage.getItem("token");
    axios
      .delete(
        `${StandardURL}/iNyumba/deleterecords/${recordIdsDel}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        toast.success("Record deleted successfully.");
      })
      .catch((error) => {
        console.error("Error deleting Record:", error);
        toast.error("Failed to delete Record.");
      });
  };

  const updateAllRecords = () => {
    const token = localStorage.getItem("token");
    axios
      .patch(
        `${StandardURL}/iNyumba/updateallrecordsadmin`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
      })
      .catch((error) => {
        console.error("Error updating records status:", error);
        toast.error(error.response.data.response);
      });
  };

  const handleDownloadRunning = (fileType) => {
    const endpoint = `${StandardURL}/iNyumba/reportsdownloadrunning`;

    // Fetch and download file
    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { format: fileType },
        responseType: "blob", // Important for file download
      })
      .then((response) => {
        const fileExtension = fileType === "pdf" ? "pdf" : "csv";
        const fileName = `inyumbapaidrentrecords.${fileExtension}`;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        toast.success("Download is successfull");
      })
      .catch((error) => {
        console.error(`Error downloading ${fileType.toUpperCase()}:`, error);
        toast.error(error.response.data.response);
      });
  };

  const handleOpenUpdateModal = (record) => {
    setRecordToUpdate(record); // Set the selected record to update
    setAmountUp(record.total_amount_paid || ""); // Set initial value for amount
    setWaterbill(record.water_bill || ""); // Set initial value for water bill
    setRentbill(record.rent_bill || ""); // Set initial value for rent bill
    setTrashbill(record.trash_bill || ""); // Set initial value for trash bill
    setServicebill(record.service_bill || ""); // Set initial value for commission
    setUpdateModalOpen(true); // Open the modal
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setUpdateModalOpen(false);
    setRecordToUpdate(null); // Clear the selected record
  };

  const handleUpdateRecordOne = (e, recordIdUse) => {
    e.preventDefault(); // Prevent default form submission
    const token = localStorage.getItem("token");

    const data = {
      amountpaid: amountup,
      waterbill: waterbill,
      rentbill: rentbill,
      trashbill: trashbill,
      servicebill: servicebill,
    };

    axios
      .patch(
        `${StandardURL}/iNyumba/updaterecordsfigures/${recordIdUse}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        toast.success("Record updated successfully.");
        setUpdateModalOpen(false); // Close the update modal after success
        navigate(-1);
        // Reset form values after action is completed
        setAmountUp("");
        setWaterbill("");
        setRentbill("");
        setTrashbill("");
        setServicebill("");
      })
      .catch((error) => {
        console.error("Error updating Record:", error);
        toast.error("Failed to update Record.");
        setUpdateModalOpen(false); // Close the update modal after failure
      });
  };


  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRecords = records.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(records.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };


  

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="flex min-h-screen flex-col items-center bg-gray-50 p-6">
          <div className="mb-8 flex w-full max-w-6xl items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="group rounded-full bg-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:bg-blue-700"
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="mr-3 transition-transform duration-300 group-hover:-translate-x-1"
              />
              Back
            </button>
            <h1 className="text-4xl font-bold tracking-tight text-gray-900">
              Transaction Records
            </h1>
          </div>

          <div className="mb-8 grid w-full max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            <div className="transform rounded-2xl bg-white p-6 shadow-lg transition-transform duration-300 hover:scale-105">
              <h2 className="mb-2 text-lg font-semibold text-gray-500">
                Actual Running Balance 💰
              </h2>
              <p className="text-3xl font-bold text-gray-900">
                {balance !== null ? `Ksh ${balance}` : "0"}
              </p>
            </div>
            <div className="transform rounded-2xl bg-white p-6 shadow-lg transition-transform duration-300 hover:scale-105">
              <h2 className="mb-2 text-lg font-semibold text-gray-500">
                Running Commissions 💸
              </h2>
              <p className="text-3xl font-bold text-gray-900">{totalCommission}</p>
            </div>
            <div className="transform rounded-2xl bg-white p-6 shadow-lg transition-transform duration-300 hover:scale-105">
              <h2 className="mb-2 text-lg font-semibold text-gray-500">
                Total Withdrawal 💳
              </h2>
              <p className="text-3xl font-bold text-gray-900">
                {actualWithdrawal !== null ? `Ksh ${actualWithdrawal.toFixed(2)}` : "0"}
              </p>
            </div>
            <div className="transform rounded-2xl bg-white p-6 shadow-lg transition-transform duration-300 hover:scale-105">
              <h2 className="mb-2 text-lg font-semibold text-gray-500">
                Running KRA Tax 📊
              </h2>
              <p className="text-3xl font-bold text-gray-900">{tax}</p>
            </div>
          </div>

          <div className="mb-8 flex w-full max-w-6xl flex-wrap justify-between gap-4">
            <div className="flex flex-col space-y-3">
              <div className="flex items-center space-x-2">
                <input
                  type="number"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  placeholder="Year (required)"
                  className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
                <input
                  type="number"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  placeholder="Month"
                  className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleFilteredDownload("csv")}
                  className="rounded-full bg-green-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-green-700"
                >
                  <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                  Download
                </button>
                <button
                  onClick={() => handleFilteredDownload("pdf")}
                  className="rounded-full bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-red-700"
                >
                  <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
                  Download
                </button>
              </div>
            </div>
            <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0">
              <button
                onClick={() => handleDownload("csv")}
                className="rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-blue-700"
              >
                <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                Download All
              </button>
              <button
                onClick={() => handleDownload("pdf")}
                className="rounded-full bg-blue-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-blue-700"
              >
                <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
                Download All
              </button>
            </div>
            <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-2 sm:space-y-0">
              <button
                onClick={() => handleDownloadRunning("csv")}
                className="rounded-full bg-purple-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-purple-700"
              >
                <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
                Download Running
              </button>
              <button
                onClick={() => handleDownloadRunning("pdf")}
                className="rounded-full bg-purple-600 px-4 py-2 text-sm font-semibold text-white transition-transform duration-200 hover:scale-105 hover:bg-purple-700"
              >
                <FontAwesomeIcon icon={faFilePdf} className="mr-2" />
                Download Running
              </button>
            </div>
            <div className="flex flex-col space-y-2">
              <button
                onClick={updateAllRecords}
                className="rounded-full bg-yellow-500 px-4 py-2 text-sm font-semibold text-gray-900 transition-transform duration-200 hover:scale-105 hover:bg-yellow-600"
              >
                Update All Records Status
              </button>
            </div>
          </div>

          <div className="w-full max-w-6xl overflow-x-auto rounded-2xl bg-white p-6 shadow-lg">
            <h2 className="mb-4 text-2xl font-bold text-gray-900">
              Record List
            </h2>
            {currentRecords.length > 0 ? (
              <>
                <table className="min-w-full table-auto text-sm">
                  <thead>
                    <tr className="bg-gray-100 text-gray-500">
                      <th className="px-4 py-3 text-left">Record ID</th>
                      <th className="px-4 py-3 text-left">User ID</th>
                      <th className="px-4 py-3 text-left">Name</th>
                      <th className="px-4 py-3 text-left">Phone</th>
                      <th className="px-4 py-3 text-left">Email</th>
                      <th className="px-4 py-3 text-left">Property ID</th>
                      <th className="px-4 py-3 text-left">Rental ID</th>
                      <th className="px-4 py-3 text-left">House Number</th>
                      <th className="px-4 py-3 text-left">Amount Paid</th>
                      <th className="px-4 py-3 text-left">Water Bill</th>
                      <th className="px-4 py-3 text-left">Rent Bill</th>
                      <th className="px-4 py-3 text-left">Trash Bill</th>
                      <th className="px-4 py-3 text-left">Service Bill</th>
                      <th className="px-4 py-3 text-left">Status</th>
                      <th className="px-4 py-3 text-left">Created At</th>
                      <th className="px-4 py-3 text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.map((record, index) => (
                      <tr
                        key={record.record_id}
                        className={`border-b transition-colors duration-200 last:border-b-0 hover:bg-gray-50`}
                      >
                        <td className="px-4 py-3">{record.record_id}</td>
                        <td className="px-4 py-3">{record.user_id}</td>
                        <td className="px-4 py-3">{record.user_name}</td>
                        <td className="px-4 py-3">{record.phone}</td>
                        <td className="px-4 py-3">{record.email}</td>
                        <td className="px-4 py-3">{record.property_id}</td>
                        <td className="px-4 py-3">{record.rental_id}</td>
                        <td className="px-4 py-3">{record.house_number}</td>
                        <td className="px-4 py-3">{record.total_amount_paid}</td>
                        <td className="px-4 py-3">{record.water_bill}</td>
                        <td className="px-4 py-3">{record.rent_bill}</td>
                        <td className="px-4 py-3">{record.trash_bill}</td>
                        <td className="px-4 py-3">{record.service_bill}</td>
                        <td className="px-4 py-3">{record.recordsstatus}</td>
                        <td className="px-4 py-3">
                          {new Date(record.created_at).toLocaleString()}
                        </td>
                        <td className="flex items-center space-x-2 px-4 py-3">
                          <button
                            onClick={() => updateOneRecord(record.record_id)}
                            className="rounded-full bg-green-600 px-3 py-1 text-xs font-semibold text-white hover:bg-green-700"
                          >
                            Update Status
                          </button>
                          <button
                            onClick={() => handleDeleteRecord(record.record_id)}
                            className="rounded-full bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-700"
                          >
                            Delete
                          </button>
                          <button
                            onClick={() => handleOpenUpdateModal(record)}
                            className="rounded-full bg-blue-600 px-3 py-1 text-xs font-semibold text-white hover:bg-blue-700"
                          >
                            Update
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="mt-8 flex items-center justify-between">
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      className="rounded-md bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Previous
                    </button>
                    <div className="flex space-x-1">
                      {Array.from({ length: totalPages }, (_, i) => (
                        <button
                          key={i + 1}
                          onClick={() => handlePageChange(i + 1)}
                          className={`rounded-md px-4 py-2 text-sm font-semibold ${
                            currentPage === i + 1
                              ? "bg-blue-600 text-white"
                              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                          }`}
                        >
                          {i + 1}
                        </button>
                      ))}
                    </div>
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      className="rounded-md bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors duration-200 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p className="text-center text-lg text-gray-500">
                No records found.
              </p>
            )}
          </div>

          {updateModalOpen && recordToUpdate && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 backdrop-blur-sm">
              <div className="w-full max-w-md transform rounded-2xl bg-white p-8 shadow-2xl transition-all duration-300">
                <h2 className="mb-6 text-2xl font-bold text-gray-900">
                  Update Record
                </h2>
                <form
                  onSubmit={(e) =>
                    handleUpdateRecordOne(e, recordToUpdate.record_id)
                  }
                  className="space-y-4"
                >
                  <input
                    type="number"
                    value={amountup || ""}
                    onChange={(e) => setAmountUp(e.target.value)}
                    placeholder="Amount Paid"
                    className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                    type="number"
                    value={waterbill || ""}
                    onChange={(e) => setWaterbill(e.target.value)}
                    placeholder="Water Bill"
                    className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                    type="number"
                    value={rentbill || ""}
                    onChange={(e) => setRentbill(e.target.value)}
                    placeholder="Rent Bill"
                    className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                    type="number"
                    value={trashbill || ""}
                    onChange={(e) => setTrashbill(e.target.value)}
                    placeholder="Trash Bill"
                    className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <input
                    type="number"
                    value={servicebill || ""}
                    onChange={(e) => setServicebill(e.target.value)}
                    placeholder="Service Bill"
                    className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  />
                  <div className="flex justify-end space-x-4 pt-4">
                    <button
                      type="button"
                      onClick={handleCloseModal}
                      className="rounded-full bg-gray-300 px-6 py-2 font-semibold text-gray-800 transition-colors duration-200 hover:bg-gray-400"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="rounded-full bg-blue-600 px-6 py-2 font-semibold text-white transition-colors duration-200 hover:bg-blue-700"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};

export default RecordsPage;
